import { EntityTileProps } from '../../../../layout/interfaces/tile';
import { CombinedDestinationType } from '../../interfaces/destinationType';

export function MergedDestinationTypeTilesFactory(
  destinations: CombinedDestinationType[],
  disableSelection: (type: CombinedDestinationType) => boolean
): Array<EntityTileProps> {
  return destinations.map((destination, index) => {
    return {
      id: destination.type,
      sortOrder: index,
      thumbnail: destination.logoUrl,
      darkModeThumbnail: destination.darkModeLogoUrl,
      title: destination.displayName,
      data: destination,
      disabled: disableSelection(destination),
      metaData: {
        enterpriseNodeLogo: destination.enterpriseNodeLogo,
        primaryColor: destination.primaryColor,
        darkModePrimaryColor: destination.darkModePrimaryColor
      }
    };
  });
}
